import React, {useState, useRef, useEffect} from 'react';
import axios from "axios";
import {toast} from "react-toastify";
import _ from "lodash";
import Input from "../../forms/Input";
import Button from "../../Button";

const ORDER_DEFAULTS = {
    id:                     "",
    quote_id:               "",
    order_type_id:          "",
    user_id:                "",
    production_due_at:      "",
    priority:               "",
    notes:                  "",
    difficulty:             "",
}

const CreateEditOrder = (props) => {
    const {
        jobId       = null,
        quoteId     = null,
        orderId     = null,
        onCancel    = () => {},
        onComplete  = () => {}
    } = props;

    const prepareDefaultValues = () => {
        const defaultOrder = ORDER_DEFAULTS;

        if (!!quoteId && quoteId !== "") {
            defaultOrder.quote_id = parseInt(quoteId);
        }

        if (!!orderId && orderId !== "") {
            defaultOrder.id = parseInt(orderId);
        }

        return defaultOrder;
    }

    const [submitting, setSubmitting]   = useState(false);
    const [priorities, setPriorities]   = useState([]);
    const [orderTypes, setOrderTypes]   = useState([]);
    const [users, setUsers]             = useState([]);
    const [notes, setNotes]             = useState(null);
    const [job, setJob]                 = useState(null);
    const [order, setOrder]             = useState(prepareDefaultValues());
    const [errors, setErrors]           = useState(null);

    useEffect(() => {
        load();
    }, [jobId, quoteId, orderId]);

    const load = () => {
        axios.get(route('web-api.job.order.config', {job: jobId, order_id: orderId, notes: notes}).toString())
            .then((response) => {
                if (!!response && !!response.data) {
                    if (!!response.data.priorities) {
                        setPriorities(response.data.priorities);
                    }

                    if (!!response.data.order_types) {
                        setOrderTypes(response.data.order_types);
                    }

                    if (!!response.data.users) {
                        setUsers(response.data.users);
                    }

                    if (!!response.data.job) {
                        setJob(response.data.job);
                    }

                    if (!!response.data.order) {
                        setOrder(response.data.order);
                    } else {
                        setOrder(prepareDefaultValues());
                    }

                    if (!!response.data.notes) {
                        setNotes(response.data.notes);
                    }
                }
            })
            .catch((error) => {
                console.log(error);
                toast.error(<div>{"An error occurred"}</div>);
                setSubmitting(false);
            });
    }

    useEffect(() => {
        if (!!submitting) {
            submit();
        }
    }, [submitting]);

    const reset = () => {
        setOrder(prepareDefaultValues());

        setSubmitting(false);
        setErrors(null);
    }

    const payload = () => {
        return {
            method: !!orderId ? 'patch' : 'post',
            url:    !!orderId ? route('web-api.job.order.update', {job: jobId, order: orderId, notes: notes}).toString() : route('web-api.job.order.store', {job: jobId}).toString(),
            data:   {
                ...order,
            },
        }
    }

    const submit = () => {
        const data = payload();
        axios(data)
            .then((response) => {
                reset();
                onComplete(response.data.order_id);
            })
            .catch((error) => {
                console.log(error);
                if (!!error.response.data && !!error.response.data.errors) {
                    setErrors(error.response.data.errors);
                    toast.error(<div>{!!error.response.data.message ? error.response.data.message : "An error occurred"}</div>);
                }

                setSubmitting(false);
            });
    }

    const handleClose = () => {
        if (!submitting) {
            reset();
            onCancel();
        }
    }

    const handleChangeDifficulty = (value) => {
        if (value != "") {
            if (value > 5.0) {
                value = 5.0;
            }
    
            if (value < 1.0) {
                value = 1.0;
            }
        }

        onChange("difficulty", value);
    }

    const onChange = (field, value) => {
        const clone = _.cloneDeep(order);

        clone[field] = value;

        setOrder(clone);
    }

    return (
        <React.Fragment>
            <div className="row m-0 p-0">
                <div className="col-12 col-lg-6 m-0 p-0 pr-lg-2 bespoke-input">
                    <Input
                        name={"production_due_at"}
                        label={"Due Date"}
                        type={"date"}
                        value={order.production_due_at}
                        disabled={submitting}
                        onChange={(value) => onChange("production_due_at", value)}
                        error={!!errors && !!errors.production_due_at ? errors.production_due_at : null}
                    />
                </div>
                <div className="col-12 col-lg-6 m-0 p-0 pl-lg-2 bespoke-input">
                    <Input
                        name={"priority"}
                        label={"Priority"}
                        required={true}
                        type={"searchable-select"}
                        options={priorities}
                        value={order.priority}
                        disabled={submitting}
                        onChange={(value) => onChange("priority", value)}
                        error={!!errors && !!errors.priority ? errors.priority : null}
                    />
                </div>
            </div>
            <div className="row m-0 p-0 ">
                <div className="col-12 col-lg-6 m-0 p-0 pr-lg-2 bespoke-input">
                    <Input
                        name={"order_type_id"}
                        label={"Type"}
                        required={true}
                        type={"searchable-select"}
                        options={orderTypes}
                        value={order.order_type_id}
                        disabled={submitting}
                        onChange={(value) => onChange("order_type_id", value)}
                        error={!!errors && !!errors.order_type_id ? errors.order_type_id : null}
                    />
                </div>
                <div className="col-12 col-lg-6 m-0 p-0 pl-lg-2 bespoke-input">
                    <Input
                        name={"user_id"}
                        label={"Assign User"}
                        type={"searchable-select"}
                        options={users}
                        value={order.user_id}
                        disabled={submitting}
                        onChange={(value) => onChange("user_id", value)}
                        error={!!errors && !!errors.user_id ? errors.user_id : null}
                    />
                </div>
            </div>
            <div className="row m-0 p-0 ">
                <div className="col-12 col-lg-6 m-0 p-0 pr-lg-2 bespoke-input">
                    <Input
                        name={"difficulty"}
                        label={"Difficulty"}
                        required={true}
                        type={"number"}
                        min={1.0}
                        max={5.0}
                        step={0.1}
                        value={order.difficulty}
                        disabled={submitting}
                        onChange={handleChangeDifficulty}
                        error={!!errors && !!errors.difficulty ? errors.difficulty : null}
                    />
                </div>
            </div>
            <div className="row m-0 mb-4 p-0 pb-2 border-bottom">
                <div className="col-12 m-0 p-0 bespoke-input">
                    <Input
                        name={"notes"}
                        label={"Notes"}
                        required={false}
                        type={"textarea"}
                        value={order.notes}
                        disabled={submitting}
                        onChange={(value) => onChange("notes", value)}
                        error={!!errors && !!errors.notes ? errors.notes : null}
                    />
                </div>
            </div>
            <div className="row m-0 p-0">
                <div className="col-12 m-0 p-0 d-flex justify-content-between align-items-center">
                    <div className="d-flex justify-content-start align-items-center">
                        <Button
                            onClick={() => setSubmitting(true)}
                            label={!!orderId ? "Save Changes" : "Convert To Order"}
                            classes={"btn btn-eh-lilac m-0 mr-4"}
                        />
                        <Button
                            onClick={() => handleClose()}
                            label={"Cancel"}
                            classes={"btn btn-outline-eh-off-black m-0 mr-4"}
                        />
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
}

export default CreateEditOrder;
